import { Modal, Button, Box, Text } from "@mantine/core";
import GreenTickMarkSvg from "../../../components/Svgs/GreenTickMarkSvg";

const ApprovalModal = ({ opened, onClose, approvalRequired }) => {
  return (
    <Modal
      centered
      size="sm"
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      overlayProps={{ blur: 3 }}
      transitionProps={{ duration: 200 }}
      radius="md"
      zIndex={1000}
    >
      <Box style={{ textAlign: "center", padding: "20px" }}>
        <GreenTickMarkSvg />
        <Text fw={600} fz="lg" mb={10} ff={"Inter"}>
          Success!
        </Text>
        <Text c="dimmed" mb={20} ff={"Inter"}>
          {approvalRequired
            ? "Approval system has been disabled"
            : "Approval system has been enabled"}
        </Text>
        <Button
          fullWidth
          color="yellow"
          onClick={onClose}
          c={"#000"}
          ff={"Inter"}
        >
          OK
        </Button>
      </Box>
    </Modal>
  );
};

export default ApprovalModal;
